import type React from 'react';

import CheckboxIcon from './checkbox-icon';
import RadioIcon from './radio-icon';


import { Box } from 'ui/box';

import { QUESTION_TYPES } from 'containers/admin/clients/client/tabs-components/ai-assistant/ai-assistant.constants';

const COLOR_TRANSITION_SX = {
  transitionProperty:
    'color, background-color, border-color, text-decoration-color, fill, stroke',
  transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1)',
  transitionDuration: '100ms',
};

interface GuidedPromptOptionProps {
  label: string;
  questionType: string;
  isSelected: boolean;
  onSelect?: (label: string) => void;
}

const GuidedPromptOption = ({
  label,
  questionType,
  isSelected,
  onSelect,
}: GuidedPromptOptionProps): React.JSX.Element => {
  const isMulti = questionType === QUESTION_TYPES.MULTI_SELECT;

  return (
    <Box
      component="button"
      type="button"
      role={isMulti ? 'checkbox' : 'radio'}
      aria-checked={isSelected}
      aria-label={label}
      onClick={() => onSelect?.(label)}
      sx={[
        {
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          width: '100%',
          px: 1.75,
          py: 1.5,
          borderRadius: '0.375rem',
          fontSize: '0.875rem',
          lineHeight: '1.25rem',
          textAlign: 'left',
          fontWeight: 400,
          cursor: 'pointer',
          ...COLOR_TRANSITION_SX,
        },
        isSelected && {
          bgcolor: 'tokens.navy.50',
          borderWidth: '2px',
          borderColor: 'tokens.navy.600',
          color: 'tokens.navy.700',
          fontWeight: 500,
        },
        !isSelected && {
          bgcolor: 'common.white',
          borderWidth: '1px',
          borderColor: 'tokens.gray.200',
          color: 'tokens.gray.700',
          '&:hover': {
            bgcolor: 'tokens.navy.50',
            borderColor: 'tokens.navy.300',
          },
        },
      ]}
    >
      <span
        aria-hidden="true"
        className="flex-shrink-0 flex items-center justify-center"
      >
        {isMulti ? (
          <CheckboxIcon isSelected={isSelected} />
        ) : (
          <RadioIcon isSelected={isSelected} />
        )}
      </span>
      <span className="flex-1 leading-5">{label}</span>
    </Box>
  );
};

export default GuidedPromptOption;
